// extracted by mini-css-extract-plugin
export var carrierTab = "_4t-0";
export var carrierTabActive = "_4t-1 _4t-0";
export var carrierTabInactive = "_4t-2 _4t-0";
export var carrierTabLabel = "_4t-3";
export var carrierTabLabelActive = "_4t-4 _4t-3";
export var carrierTabLabelInactive = "_4t-5 _4t-3";
export var carrierTabPercentage = "_4t-6";
export var carrierTabPercentageActive = "_4t-7 _4t-6";
export var carrierTabPercentageInactive = "_4t-8 _4t-6";
export var carrierTabWinnable = "_4t-9";
export var carrierTabWinnableActive = "_4t-a _4t-9";
export var carrierTabWinnableInactive = "_4t-b _4t-9";
export var comparisonContainer = "_4t-d";
export var missingRateButton = "_4t-n";
export var missingRateButtonActive = "_4t-o _4t-n";
export var missingRateButtonInactive = "_4t-p _4t-n";
export var missingRateButtonLabel = "_4t-q";
export var missingRateButtonLabelActive = "_4t-r _4t-q";
export var missingRateButtonLabelInactive = "_4t-s _4t-q";
export var sidebar = "_4t-c";
export var strategyButton = "_4t-e";
export var strategyButtonActive = "_4t-f _4t-e";
export var strategyButtonDescription = "_4t-k";
export var strategyButtonDescriptionActive = "_4t-l _4t-k";
export var strategyButtonDescriptionInactive = "_4t-m _4t-k";
export var strategyButtonInactive = "_4t-g _4t-e";
export var strategyButtonLabel = "_4t-h";
export var strategyButtonLabelActive = "_4t-i _4t-h";
export var strategyButtonLabelInactive = "_4t-j _4t-h";
export var unitToggleButton = "_4t-t";
export var unitToggleButtonActive = "_4t-u _4t-t";
export var unitToggleButtonInactive = "_4t-v _4t-t";
export var unitToggleButtonLabel = "_4t-w";
export var unitToggleButtonLabelActive = "_4t-x _4t-w";
export var unitToggleButtonLabelInactive = "_4t-y _4t-w";